<div class="public-header" *ngIf="data" [ngClass]="{ preview: isPreview }">
	<div class="container">
		<div class="row align-items-center">
			<div [ngClass]="isPreview ? 'col-auto' : 'col-auto d-md-none'">
				<a class="button icon" href="{{ data.canonicalURL }}">
					<i class="material-icons"> chevron_left </i>
				</a>
			</div>
			<div class="col">
				<div class="public-header__profile">
					<div class="row align-items-center g-2">
						<div [ngClass]="isPreview ? 'd-none' : 'col-auto d-none d-md-flex'">
							<figure class="public-header__avatar">
								<img src="{{ data.pictureUrl }}" alt="{{ data.name }}" />
							</figure>
						</div>
						<div class="col">
							<h2>
								{{ data.name }}
								<span>{{ data.tagline }}</span>
							</h2>
						</div>
					</div>
				</div>
			</div>
			<div class="col-auto">
				<div [ngClass]="isPreview ? 'd-none' : 'd-none d-md-flex'">
					<a class="button" href="{{ data.canonicalURL }}">
						<i class="material-icons"> chevron_left </i>
						Return to card
					</a>
				</div>

				<div [ngClass]="isPreview ? 'd-flex' : 'd-flex d-md-none'">
					<figure class="public-header__avatar">
						<img src="{{ data.pictureUrl }}" alt="{{ data.name }}" />
					</figure>
				</div>
			</div>
		</div>
	</div>
</div>
